import React from "react";

/** Shared Reveal / Shield / Freeze icon (image with emoji fallback). */
export default function BoostIcon({
    boost = null,
    className = "",
    size = 28,
}) {
    if (!boost) {
        return null;
    }

    if (boost.iconSrc) {
        return (
            <img
                className={`boostIcon ${className}`.trim()}
                src={boost.iconSrc}
                alt=""
                width={size}
                height={size}
                draggable="false"
            />
        );
    }

    return (
        <span className={`boostIcon boostIcon--emoji ${className}`.trim()} aria-hidden="true">
            {boost.icon}
        </span>
    );
}
